import React from 'react'
import './taskCard.css'
import { useSelector } from 'react-redux'
import moment from 'moment'

const TaskCard = () => {
    const {user} = useSelector((state)=> state.user)

    const today = new Date()
    const currentMonth = today.getMonth() + 1
    const currentYear = today.getFullYear()

    const filterTodolist = user?.todolist?.filter((item)=> {
        return moment(item?.month).month() === moment().month() && String(item?.year) === String(currentYear)
    })
    const mappedTodo = filterTodolist[0]?.todolist

  return (
    <div className='task__card'>
        <h4 className="task__card-title">
            Tasks
        </h4>
        <div className="task__card-list">
            <div className="task__card-list_item total">
                <h4 className="task__card-list_count">{mappedTodo?.length}</h4>
                <span className="task__card-list_name">
                    Total Tasks
                </span>
            </div>
            <div className="task__card-list_item completed">
                <h4 className="task__card-list_count">
                    {mappedTodo?.filter((item)=>item?.status === 'Completed')?.length}
                </h4>
                <span className="task__card-list_name">Completed Task</span>
            </div>
            <div className="task__card-list_item waiting">
                <h4 className="task__card-list_count">
                    {mappedTodo?.filter((item)=>item?.status === 'Waiting')?.length}
                </h4>
                <span className="task__card-list_name">Waiting Task</span>
            </div>
            <div className="task__card-list_item inprogress">
                <h4 className="task__card-list_count">
                    {mappedTodo?.filter((item)=>item?.status === 'InProgress')?.length}
                </h4>
                <span className="task__card-list_name">InProgress Task</span>
            </div>
        </div>
    </div>
  )
}

export default TaskCard